var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M30.2,16.6h-3.5v-1.5c0-0.3-0.2-0.5-0.5-0.5h-1v-2h1c0.3,0,0.5-0.2,0.5-0.5v-4c0-0.3-0.2-0.5-0.5-0.5h-4.9 c-0.3,0-0.5,0.2-0.5,0.5v0.5h-4.5c-1.6-0.1-2.9,1.2-3,2.8c0,0.1,0,0.1,0,0.2v1.5c0,0.3,0.2,0.5,0.5,0.5h2c0.3,0,0.5-0.2,0.5-0.5 v-1.5h4.5v0.5c0,0.3,0.2,0.5,0.5,0.5h1v2h-1c-0.3,0-0.5,0.2-0.5,0.5v1.5h-3.5c-0.8,0-1.4,0.6-1.5,1.4v18c0.1,0.8,0.7,1.4,1.5,1.4 h12.9c0.8,0,1.4-0.6,1.5-1.4V18C31.6,17.2,31,16.6,30.2,16.6z M30.7,18v3.5h-6.5v-2h0.5c0.3,0,0.5-0.2,0.5-0.5v-1.5h5 C30.5,17.5,30.7,17.7,30.7,18z M16.8,33.5h13.9V36c0,0.3-0.2,0.5-0.5,0.5H17.3c-0.3,0-0.5-0.2-0.5-0.5V33.5z M30.7,32.5H16.8v-10 h13.9V32.5z M17.3,17.5h5V19c0,0.3,0.2,0.5,0.5,0.5h0.4v2h-6.4V18C16.8,17.7,17,17.5,17.3,17.5z M24.2,18.5h-1v-1h1V18.5z  M14.3,12.6v-1c0-1.1,0.9-2,2-2h4.5v1h-4.5c-0.5-0.1-0.9,0.3-1,0.8c0,0.1,0,0.1,0,0.2v1H14.3z M23.2,12.6h1v2h-1V12.6z M21.8,15.6 h3.9v1h-3.9V15.6z"
});

var _ref3 = /*#__PURE__*/React.createElement("polygon", {
  fill: "#A1A1A1",
  points: "24.7,16.6 25.7,16.6 25.7,15.6 24.7,15.6 22.8,15.6 21.8,15.6 21.8,16.6 22.8,16.6 "
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#F9F9F9",
  d: "M30.2,17.5h-5V19c0,0.3-0.2,0.5-0.5,0.5h-0.5v2h6.5V18C30.7,17.7,30.5,17.5,30.2,17.5z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#F9F9F9",
  d: "M16.8,21.5h6.4v-2h-0.4c-0.3,0-0.5-0.2-0.5-0.5v-1.5h-5c-0.3,0-0.5,0.2-0.5,0.5V21.5z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#F9F9F9",
  d: "M17.3,36.5h12.9c0.3,0,0.5-0.2,0.5-0.5v-2.5H16.8V36C16.8,36.3,17,36.5,17.3,36.5z"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 23.2,
  y: 17.5,
  fill: "#A1A1A1",
  width: 1,
  height: 1
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 23.2,
  y: 12.6,
  fill: "#A1A1A1",
  width: 1,
  height: 2
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "#C9C9C9",
  d: "M15.3,11.6c-0.1-0.5,0.3-0.9,0.8-1c0.1,0,0.1,0,0.2,0h4.5v-1h-4.5c-1.1,0-2,0.9-2,2v1h1V11.6z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fill: "#F9F9F9",
  d: "M16.8,22.5v10h13.9v-10H16.8z M23.7,31.5c-2.2,0-4-1.8-4-4s1.8-4,4-4c2.2,0,4,1.8,4,4S25.9,31.5,23.7,31.5z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fill: "#F9F9F9",
  d: "M26.7,27.5c0-1.7-1.3-3-3-3c-1.7,0-3,1.3-3,3s1.3,3,3,3C25.4,30.5,26.7,29.2,26.7,27.5z M25.2,28h-1v1 c0,0.3-0.2,0.5-0.5,0.5s-0.5-0.2-0.5-0.5v-1h-0.9c-0.3,0-0.5-0.2-0.5-0.5S22,27,22.3,27h0.9v-1c0-0.3,0.2-0.5,0.5-0.5 s0.5,0.2,0.5,0.5v1h1c0.3,0,0.5,0.2,0.5,0.5S25.5,28,25.2,28z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M27.7,27.5c0-2.2-1.8-4-4-4c-2.2,0-4,1.8-4,4s1.8,4,4,4C25.9,31.5,27.7,29.7,27.7,27.5z M23.7,30.5 c-1.7,0-3-1.3-3-3s1.3-3,3-3c1.7,0,3,1.3,3,3S25.4,30.5,23.7,30.5z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fill: "#F2724A",
  d: "M25.7,27.5c0-0.3-0.2-0.5-0.5-0.5h-1v-1c0-0.3-0.2-0.5-0.5-0.5s-0.5,0.2-0.5,0.5v1h-0.9 c-0.3,0-0.5,0.2-0.5,0.5S22,28,22.3,28h0.9v1c0,0.3,0.2,0.5,0.5,0.5s0.5-0.2,0.5-0.5v-1h1C25.5,28,25.7,27.8,25.7,27.5z"
});

function SvgHandSanitizer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandSanitizer);
export default __webpack_public_path__ + "static/media/hand_sanitizer.37ca3235b575082a40d76398d225f5cc.svg";
export { ForwardRef as ReactComponent };